import React , { useState , useMemo}from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { createTruncatedTextForTable } from '../../../../utils/textUtils';
import StickyScrollTable from '../../../../components/common/StickyScrollTable';
import PreferencesDataTable from '../../../../components/common/PreferencesDataTable';

export default function VehicleWarrantyClaimsTable({ items, totalCount, loading, lazyParams, onPage, columns }) {
    const { th } = useLanguage();

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const formatDate = (value) => {
    if (!value) return '-';

    if (typeof value === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
        return value;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;
    
    return date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

    const formatCurrency = (value) => {
        if (value == null) return '-';
        return Number(value).toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const parts = dateStr.split('.');
        if (parts.length === 3) {
            return new Date(parts[2], parts[1] - 1, parts[0]);
        }
        return new Date(dateStr);
    };
    const sortedItems = useMemo(() => {
        if (!sortField || !sortOrder) return items;

        const sorted = [...items].sort((a, b) => {
            let aVal = a[sortField];
            let bVal = b[sortField];

            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return sortOrder;
            if (bVal == null) return -sortOrder;


            const col = columns.find(c => c.field === sortField);
            if (col?.dataType === 'date' || /tarih|date/i.test(sortField)) {
                const dateA = parseDate(aVal);
                const dateB = parseDate(bVal);
                if (dateA && dateB) {
                    return sortOrder * (dateA.getTime() - dateB.getTime());
                }
            }

            if (typeof aVal === 'number' && typeof bVal === 'number') {
                return sortOrder * (aVal - bVal);
            }

            const strA = String(aVal).toLowerCase();
            const strB = String(bVal).toLowerCase();
            return sortOrder * strA.localeCompare(strB, 'tr-TR');
        });

        return sorted;
    }, [items, sortField, sortOrder, columns]);

     const rows = Array.isArray(sortedItems)
        ? sortedItems.map((item, index) => ({ ...item, _rowId: `${lazyParams.first}-${index}` }))
        : [];
   const getColumnBody = (col) => {
    if (col.body) return col.body;

    const field = col.field;

    if (col.dataType === 'date') {
        return (row) => formatDate(row?.[field]);
    }

    if (col.dataType === 'currency') {
        return (row) => formatCurrency(row?.[field]);
    }

    // Truncate kolonları
    if (col.truncate) {
        return (row) => {
            const value = row?.[field];
            if (value == null || value === '') return '-';
            return createTruncatedTextForTable(String(value), 40);
        };
    }

    // Varsayılan
    return (row) => (row?.[field] != null && row?.[field] !== '' ? row[field] : '-');
};
     const onSort = (event) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder);
    };

    const prefColumns = useMemo(
        () =>
            (columns || []).map((col) => ({
                field: col.field,
                columnKey: col.field,
                header: col.header,
                sortable: true,
                body: getColumnBody(col),
                style: { minWidth: col.minWidth || '150px' }
            })),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [columns]
    );

    return (
        <StickyScrollTable deps={[rows, columns]} scrollBarPosition="top">
            <PreferencesDataTable
                tableKey="vehicle-warranty-claims-report"
                columns={prefColumns}
                value={rows}
                dataKey="_rowId"
                lazy
                paginator
                rows={lazyParams.rows}
                first={lazyParams.first}
                totalRecords={totalCount}
                onPage={onPage}
                loading={loading}
                emptyMessage={th('common.noRecords')}
                rowsPerPageOptions={[10, 25, 50]}
                showGridlines
                tableStyle={{ minWidth: '100%' }}
                sortField={sortField}
                sortOrder={sortOrder}
                onSort={onSort}
                pt={{ wrapper: { style: { overflowX: 'scroll' } } }}
            />
        </StickyScrollTable>
    );
}